module.exports = __webpack_public_path__ + "static/media/chest_press_machine.a0602da7.png";